import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc)

export default interface Campaign {
  id: string;
  campaignPlan: campaignPlans;
  campaignName: string;
  discount: number;
  startDate?: string;
  endDate: string;
  source?: string;
  startingPlan?: string;
  deviceIds?: Array<string>;
  notificationText?: string;
  status?: string;
  banner?: {
    text: string;
    buttonText: string;
    buttonColor: string;
    image: string;
  };
  details?: {
    title: string;
    description: string;
    detail: string;
    buttonColor: string;
    image: string;
  };
};

export type campaignPlans = "" | "1_year" | "2_year_regular" | "3_years" | "indiegogo";

export function adaptCampaignApiReponse(response: any): Array<Campaign> {
  let mappedResults: Array<Campaign> = [];

  if (!response.campaigns || !Array.isArray(response.campaigns)) {
    return mappedResults;
  }
  mappedResults = response.campaigns.map((campaign) => {
    let adaptedcampaign: Campaign = {
      id: campaign.campaignName,
      campaignPlan: campaign.campaignPlan,
      campaignName: campaign.campaignName || "-",
      discount: campaign.discount || 0,
      endDate: dayjs.utc(campaign.endDate).format("MM/DD/YYYY") || "-",
      startDate: dayjs.utc(campaign.startDate).format("MM/DD/YYYY") || "-",
      source: campaign.source,
      startingPlan: campaign.startingPlan,
      banner: campaign.banner || null,
      details: campaign.details || null,
      notificationText: campaign.notificationText || "",
      deviceIds: campaign.deviceIds ? campaign.deviceIds : [],
      status: dayjs(campaign.endDate) >= dayjs() ? "Active" : "Finished"
    };

    return adaptedcampaign;
  });

  return mappedResults;
}
